import { chipCompoundVariants, chipDisabledVariants, chipElevatedVariants, chipEmphasisVariants, filterChipDefaultVariants, filterChipSlots, filterChipTypeVariants } from "../../variants/index.js";
import { tv } from "../../variants/tv.js";
const filterChipVariants = tv({
    slots: filterChipSlots,
    variants: {
        type: filterChipTypeVariants,
        disabled: chipDisabledVariants,
        elevated: chipElevatedVariants,
        emphasis: chipEmphasisVariants,
        hasHelperText: {
            true: {},
            false: {}
        },
        hasIconLeft: {
            true: {
                checkIconSlot: 'absolute'
            }
        },
        isChipRange: {
            true: {
                chipRangeSlot: 'w-full'
            },
            false: {}
        },
        selectedState: {
            true: {
                checkIconSlot: 'duration-medium',
                iconLeftSlot: 'duration-medium scale-0 opacity-0',
                faviconSlot: 'duration-medium w-0 scale-0 opacity-0'
            },
            false: {
                checkIconSlot: 'duration-short !w-[0] scale-0 opacity-0',
                iconLeftSlot: 'duration-short',
                faviconSlot: 'duration-short'
            }
        },
        hasCount: {
            true: {
                countSlot: 'duration-medium scale-100 pr-1 opacity-100 transition-all'
            },
            false: {
                countSlot: 'duration-short scale-0 pr-0 opacity-0 transition-all'
            }
        },
        showCheckIcon: {
            true: {},
            false: {}
        }
    },
    compoundVariants: chipCompoundVariants,
    defaultVariants: filterChipDefaultVariants
});
export { filterChipVariants };
